export default "__VITE_ASSET__DTDwmknC__"